<template>
  <div class="menu-bar" :class="menuClass">
    <button class="menu-bar__hamburger" @click="toggleMenu">
      <div class="hamburger hamburger--elastic" :class="hamburgerClass">
        <div class="hamburger-box">
          <div class="hamburger-inner"></div>
        </div>
      </div>
    </button>

    <div class="menu-bar__title">
      <slot name="title"></slot>
    </div>

   <div class="menu-bar__menu">
      <slot name="categories"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'menu-bar',
  data () {
    return {
      menuOpen: false
    };
  },
  computed: {
    menuClass () {
      const open = this.menuOpen ? 'open' : 'closed';
      return `${open}`;
    },
    hamburgerClass () {
      return this.menuOpen ? `is-active` : '';
    }
  },
  methods: {
    toggleMenu () {
      this.setMenuState(!this.menuOpen);
    },
    setMenuState (state) {
      this.menuOpen = state;
    }
  },
  watch: {
    '$route' () {
      this.setMenuState(false);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.menu-bar {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__hamburger {
    display: none;

    position: fixed;
    z-index: 10;

    top: 18px;
    left: -2px;

    padding: 0;
    margin: 0;
    background: none;
    border: 0px;

    &:focus {
      outline:0;
    }

    @media only screen and (max-width: 512px) { 
      display: block;
    }
  }

  &__title {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-bottom: 2rem;

    a:hover {
      text-decoration: none;
    }
  }

  &__menu {
    transition: transform 200ms;
    transform: translateX(0%);

    @media only screen and (max-width: 512px) { 
      position: fixed;
      top: 0;
      left: 0;
      
      width: 100%;
      height: 100vh;
      z-index: 9;
      background: $color-accent;
    }
  }

  @media only screen and (max-width: 512px) { 
    &.closed {

      .menu-bar__menu {
        transform: translateX(-100%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MenuBar.vue?650d98ce